import { useEffect, useId, useRef, useState } from 'react'
import { dateRangeLabel } from '../lib/format'
import { Icon } from './Icon'

export interface DateRange {
  from?: string
  to?: string
}

export function DateRangeFilter({ value, onChange }: { value: DateRange; onChange: (range: DateRange) => void }) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const panelId = useId()
  useEffect(() => {
    if (!open) return
    const down = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false) }
    const key = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', down)
    document.addEventListener('keydown', key)
    return () => { document.removeEventListener('mousedown', down); document.removeEventListener('keydown', key) }
  }, [open])
  return (
    <div className="daterange" ref={ref}>
      <button type="button" className="daterange__button" aria-expanded={open} aria-controls={open ? panelId : undefined} onClick={() => setOpen((o) => !o)}>
        <Icon name="calendar" size={16} />
        <span>{dateRangeLabel(value.from, value.to)}</span>
        <Icon name="chevron-down" size={14} />
      </button>
      {open ? (
        <div id={panelId} role="dialog" aria-label="Rango de fechas" className="daterange__panel">
          <label className="field__label" htmlFor={`${panelId}-from`}>Desde</label>
          <input id={`${panelId}-from`} type="date" value={value.from ?? ''} max={value.to || undefined} onChange={(e) => onChange({ ...value, from: e.target.value || undefined })} />
          <label className="field__label" htmlFor={`${panelId}-to`}>Hasta</label>
          <input id={`${panelId}-to`} type="date" value={value.to ?? ''} min={value.from || undefined} onChange={(e) => onChange({ ...value, to: e.target.value || undefined })} />
          <button type="button" className="btn btn--ghost btn--sm" onClick={() => onChange({})}>Última inspección de cada equipo</button>
        </div>
      ) : null}
    </div>
  )
}
